import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ApiTranslateLoader } from './api-translate-loader';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ChatComponent } from '../components/chat/chat.component';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { MenuBarComponent } from '../components/menu-bar/menu-bar.component';
import { MessagePopComponent } from '../components/message-pop/message-pop.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { ModalModule } from "angular-bootstrap-md";
import { LinkyModule } from 'ngx-linky';
import { PickerModule } from '@ctrl/ngx-emoji-mart';


import { AboutComponent } from './about/about.component';
import { BecomeAPeerSupportComponent } from './become-a-peer-support/become-a-peer-support.component';
import { ChangeLanguageComponent } from './change-language/change-language.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { HelpUsComponent } from 'src/app/help-us/help-us.component';
import { MenuComponent } from './menu/menu.component';
import { ModalComponent } from './modal/modal.component';
import { SelfCareComponent } from './self-care/self-care.component';
import { SetLanguageComponent } from './set-language/set-language.component';
import { PolicyHomeComponent } from './policy-home/policy-home.component';
import { PolicyTermsComponent } from './policy-terms/policy-terms.component';
import { ResourcesComponent } from './resources/resources.component';
import { SafetyPlanComponent } from './safety-plan/safety-plan.component';
import { SocketService } from 'src/services/socket/socket.service';
import { SafeHtmlPipe } from 'src/pipes/safe-html.pipe';

@NgModule({
  declarations: [
    AboutComponent,
    AppComponent,
    BecomeAPeerSupportComponent,
    ChatComponent,
    ChangeLanguageComponent,
    ContactUsComponent,
    DisclaimerComponent,
    HelpUsComponent,
    HomeComponent,
    MenuComponent,
    MenuBarComponent,
    MenuComponent,
    MessagePopComponent,
    ModalComponent,
    PolicyHomeComponent,
    PolicyTermsComponent,
    ResourcesComponent,
    SafetyPlanComponent,
    SelfCareComponent,
    SetLanguageComponent,
    SafeHtmlPipe
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    LinkyModule,
    MaterialModule,
    PickerModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  providers: [SocketService, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function createTranslateLoader(http: HttpClient) {
  return new ApiTranslateLoader(http);
}
